module.exports = __webpack_public_path__ + "static/media/morning-icon.b370ead7.svg";